import OrderBasketList from './List'
import OrderEdit from '../Order/Edit'
import OrderCreate from '../Order/Create'

export default {
  list: OrderBasketList,
  edit: OrderEdit,
  create: OrderCreate
}
